import { SITE_IDS, type SiteId } from '@pkg/config/sanity/audience';
import { SINGLETON } from '@pkg/config/sanity/schemas';
import { singletonDocId } from './singletonDocId';

/**
 * SEO + Social is one schema with a document per audience.
 * www keeps the original id. Business is the same id with a `-business` suffix.
 */
export function seoConfigDocumentId(siteId: SiteId = SITE_IDS.WWW): string {
  return siteId === SITE_IDS.BUSINESS
    ? singletonDocId(SINGLETON.CONFIG_SEO, undefined, SITE_IDS.BUSINESS)
    : singletonDocId(SINGLETON.CONFIG_SEO);
}

export function audienceFromSeoConfigDocumentId(
  documentId: string | undefined | null,
): SiteId | undefined {
  if (!documentId) {
    return undefined;
  }

  const publishedId = documentId
    .replace(/^drafts\./, '')
    .replace(/^versions\.[^.]+\./, '');

  if (publishedId === seoConfigDocumentId(SITE_IDS.BUSINESS)) {
    return SITE_IDS.BUSINESS;
  }

  if (publishedId === seoConfigDocumentId(SITE_IDS.WWW)) {
    return SITE_IDS.WWW;
  }

  return undefined;
}
